import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=34b265ca&scoped=true&"
import script from "./Introduce.vue?vue&type=script&lang=js&"
export * from "./Introduce.vue?vue&type=script&lang=js&"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=34b265ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b265ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b265ca')) {
      api.createRecord('34b265ca', component.options)
    } else {
      api.reload('34b265ca', component.options)
    }
    module.hot.accept("./Introduce.vue?vue&type=template&id=34b265ca&scoped=true&", function () {
      api.rerender('34b265ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/music/comp/Lesson/Introduce.vue"
export default component.exports